import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { PenLine, Trash2, Loader2 } from "lucide-react";

export function FirmaIntermediario({ it, onChange }) {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const id = it.intermediary_id;
  useEffect(() => {
    if (!it.firma) { setUrl(null); return; }
    let u;
    api.get(`/mup/intermediaries/${id}/firma`, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => setUrl(null));
    return () => u && URL.revokeObjectURL(u);
  }, [id, it.firma?.sha256]); // eslint-disable-line react-hooks/exhaustive-deps
  const err = (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail));
  const carica = async (file) => {
    if (!file) return; setBusy(true);
    const fd = new FormData(); fd.append("file", file);
    try { const { data } = await api.post(`/mup/intermediaries/${id}/firma`, fd); toast.success(`Firma caricata: comparirà sui nuovi MUP${data.mup_rigenerati ? ` — ${data.mup_rigenerati} MUP non ancora inviati rigenerati con la firma` : ""}`); onChange(); } catch (e) { err(e); } finally { setBusy(false); }
  };
  const rimuovi = async () => { try { await api.delete(`/mup/intermediaries/${id}/firma`); toast.success("Firma rimossa"); onChange(); } catch (e) { err(e); } };
  return (
    <div className="mt-3 pt-3 border-t border-slate-100" data-testid={`int-firma-${id}`}>
      {url ? <img src={url} alt={`Firma di ${it.name}`} className="h-12 max-w-[220px] object-contain" data-testid={`int-firma-img-${id}`} />
        : <p className="text-[11px] text-slate-400">Nessuna firma: il riquadro "Firma intermediario proponente" del MUP resta vuoto.</p>}
      <div className="flex gap-3 mt-1.5 text-xs">
        <label className="text-teal-700 cursor-pointer inline-flex items-center gap-1" data-testid={`int-firma-carica-${id}`}>
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <PenLine className="h-3.5 w-3.5" />}{it.firma ? "Sostituisci firma" : "Carica firma"}
          <input type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={(e) => { carica(e.target.files[0]); e.target.value = ""; }} data-testid={`int-firma-file-${id}`} /></label>
        {it.firma && <button onClick={rimuovi} className="text-slate-400 hover:text-red-600 inline-flex items-center gap-1" data-testid={`int-firma-rimuovi-${id}`}><Trash2 className="h-3.5 w-3.5" /> Rimuovi</button>}
      </div>
    </div>
  );
}
